module.exports = __webpack_public_path__ + "img/office3.a4d3b2d4.jpg";